import React, { Component } from 'react';
import TitleBody from './titleBody';

class Accordion extends Component {
  render() {
    return this.props.config.field_row.map((item, i) => 
      <TitleBody key={i} data={item} checked={this.props.config.field_boolean_1} />
    );
  }
}

export default Accordion;
